class LockTTStore {
    constructor() {
        this.dateRangeConfig = null;
        this.usersSelectorConfig = null;
        this.features = null;
        this.pagerConfig = null;
        this.lockedTillDate = null;
        this.selectionVeilImages = null;
        this.usersForSelector = null;
        this.timeZoneForSelector = null;
        this.usersGroupsForSelector = null;
        this.dateFormat = null;
        this.sortingOrder = null;
        this.timestamp = null;
        this.lockTableImagesLoaded = false;
        this.allLockedTillDateBeyondDateRange = null;
        this.deletedUsers = null;
        this.users = null;
        this.weekStartDay = null;
        this.loggedInUserToday = null;
        this.headerData = null;
        this.disabledUsersSelected = null;
        this.months = null;
        this.userDataGroups = null;
        this.userGroupFeature = false;
        this.timeZoneGroupFeature = false;
        this.calendarConfig = {
            invertedDaysDateMap: null,
            defaultUserSchedule: []
        };
        this.hideDetailsOnLockTT = false
    }

    setDateRangeConfig(config) {
        this.dateRangeConfig = config;
    }

    getDateRangeConfig() {
        return this.dateRangeConfig;
    }

    setUsersSelectorConfig(config) {
        this.usersSelectorConfig = config;
    }

    getUsersSelectorConfig() {
        return this.usersSelectorConfig;
    }

    setEnabledFeatures(features) {
        this.features = features;
    }

    getEnabledFeatures() {
        return this.features;
    }

    setPagerConfig(config) {
        this.pagerConfig = config;
    }

    getPagerConfig() {
        return this.pagerConfig;
    }

    setLockedTillDate(lockedTillDate) {
        this.lockedTillDate = lockedTillDate;
    }

    getLockedTillDate() {
        return this.lockedTillDate;
    }

    setSelectionVeilImages(selectionVeilImages) {
        this.selectionVeilImages = selectionVeilImages;
    }

    getSelectionVeilImages() {
        return this.selectionVeilImages;
    }

    setUsersForSelector(users) {
        this.usersForSelector = users;
    }

    getUsersForSelector() {
        return this.usersForSelector;
    }

    setTimeZonesForSelector(timezones) {
        this.timeZoneForSelector = timezones;
    }

    getTimeZonesForSelector() {
        return this.timeZoneForSelector;
    }

    setUsersGroupsForSelector(usersGroups) {
        this.usersGroupsForSelector = usersGroups;
    }

    getUsersGroupsForSelector() {
        return this.usersGroupsForSelector;
    }

    getDateFormat() {
        return this.dateFormat;
    }

    setDateFormat(dateFormat) {
        this.dateFormat = dateFormat;
    }

    getSortingOrder() {
        return this.sortingOrder;
    }

    setSortingOrder(sortingOrder) {
        this.sortingOrder = sortingOrder;
    }

    setTimestamp(timestamp) {
        this.timestamp = timestamp;
    }

    getTimestamp() {
        return this.timestamp;
    }

    setLockTableImagesLoaded(lockTableImagesLoaded) {
        this.lockTableImagesLoaded = lockTableImagesLoaded;
    }

    isLockTableImagesLoaded() {
        return this.lockTableImagesLoaded;
    }

    setAllLockedTillDateBeyondDateRange(allLockedTillDateBeyondDateRange) {
        this.allLockedTillDateBeyondDateRange = allLockedTillDateBeyondDateRange;
    }

    getAllLockedTillDateBeyondDateRange() {
        return this.allLockedTillDateBeyondDateRange;
    }

    setDeletedUsers(deletedUsers) {
        this.deletedUsers = deletedUsers;
    }

    getDeletedUsers() {
        return this.deletedUsers;
    }

    setUsers(users) {
        this.users = users;
    }

    getUsers() {
        return this.users;
    }

    setWeekStartDay(weekStartDay) {
        this.weekStartDay = weekStartDay;
    }

    getWeekStartDay() {
        return this.weekStartDay;
    }

    setLoggedInUserToday(loggedInUserToday) {
        this.loggedInUserToday = loggedInUserToday;
    }

    getLoggedInUserToday() {
        return this.loggedInUserToday;
    }

    setHeaderData(headerData) {
        this.headerData = headerData;
    }

    getHeaderData() {
        return this.headerData;
    }

    setDisabledUsersSelected(disabledUsersSelected) {
        this.disabledUsersSelected = disabledUsersSelected;
    }

    getDisabledUsersSelected() {
        return this.disabledUsersSelected;
    }

    setMonths(months) {
        this.months = months;
    }

    getMonths() {
        return this.months;
    }

    setUserDataGroups(userDataGroups) {
        this.userDataGroups = userDataGroups;
    }

    getUserDataGroups() {
        return this.userDataGroups;
    }

    setFeaturesForSelector(userGroupFeature, timeZoneGroupFeature) {
        this.userGroupFeature = userGroupFeature;
        this.timeZoneGroupFeature = timeZoneGroupFeature;
    }

    getUserGroupFeatureForSelector() {
        return this.userGroupFeature;
    }

    getTimeZoneGroupFeatureForSelector() {
        return this.timeZoneGroupFeature;
    }

    setCalendarConfig(config) {
        this.calendarConfig = config
    }

    getCalendarConfig() {
        return this.calendarConfig
    }

    setHideDetailsOnLockTT(hideDetailsOnLockTT) {
        this.hideDetailsOnLockTT = hideDetailsOnLockTT
    }

    isHideDetailsOnLockTT() {
        return this.hideDetailsOnLockTT
    }
}

export default new LockTTStore();


// WEBPACK FOOTER //
// ./web/js/user/locktt/LockTTStore.js